import Cookies from 'js-cookie';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Logout = () => {
  const { logout } = useAuth();  
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();  

  // Fonction de gestion de la déconnexion
  const handleLogout = async () => {
    setLoading(true);  // Activer le loading pendant la déconnexion

    try {
      // Effectuer l'appel à l'API de déconnexion
      const response = await fetch('/auth/logout', {
        method: 'POST',
        credentials: true,  // Inclure les cookies (si utilisés pour stocker le token)
      });

      // Vérifier si la requête a réussi
      if (!response.ok) {
        throw new Error('Erreur lors de la déconnexion, code de statut : ' + response.status);
      }

      const data = await response.json();
      if (data.success) {
        // Si la déconnexion a réussi, supprimer le token localement
        Cookies.remove('access_token', { path: '/' });
        Cookies.remove('refresh_token', { path: '/' });

        // Mettre à jour l'état d'authentification dans le contexte
        logout();
        
        console.log('Utilisateur déconnecté avec succès');
        navigate('/home-page');  // Redirection vers la page de connexion
      } else {
        throw new Error(data.message || 'Erreur lors de la déconnexion.');
      }
    } catch (err) {
      console.error('Erreur de déconnexion', err);
    } finally {
      setLoading(false);  // Désactiver le loading
    }
  };

  return (
    <div className="logout-container min-h-screen flex justify-center items-center bg-gray-100">
      <div className="bg-white p-8 rounded-md shadow-md w-80">
        <h2 className="text-2xl font-semibold text-center mb-6">Déconnexion</h2>

        {/* Afficher l'erreur si elle existe */}
        {loading && <p className="text-blue-500 text-center mb-4">Déconnexion en cours...</p>}

        <button
          onClick={handleLogout}
          className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-700 transition-all"
          disabled={loading}
        >
          {loading ? 'Déconnexion en cours...' : 'Se déconnecter'}
        </button>
      </div>
    </div>
  );
};

export default Logout;
